import { FunctionComponent } from 'react';
import { CPMainModal } from 'widgets/auth/createPassword/_MainModal';

export const CreatePassword: FunctionComponent = () => {
	return <CPMainModal />;
};
